import { AppConfig } from '../../app/app.config';

export const ALL_CHANNELS = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
  AppConfig.Shared.EventTracker.MIXPANEL,
  AppConfig.Shared.EventTracker.AMPLITUDE,
];

export const CHANNELS_EXCLUDING_MIXPANEL = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
  AppConfig.Shared.EventTracker.AMPLITUDE,
];

export const PRIMARY_CHANNELS = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
];

export const DEFAULT_EVENT_TRACKER_CHANNELS = [
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.AMPLITUDE,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.MOENGAGE,
];

export const AMPLITUDE_SUPPRESSED_EVENTS = [
  'pageOpen',
  'impression',
  'exit',
];

/**
 * Base names of analytics events that fire a `_HAIR` variant for HAIR regimens
 * and the base name for FACE / BODY. The `_HAIR` suffix is not listed here — it
 * is computed by `EventLoggerService.getEventNameForClass`.
 */
export enum FirebaseAndBranchEvent {
  BUY_NOW_CLICKED = 'BUY_NOW_CLICKED',
  REGIMEN_VIEWED = 'REGIMEN_VIEWED',
  PRODUCT_VIEWED = 'PRODUCT_VIEWED',
  REGIMEN_CLICKED = 'REGIMEN_CLICKED',
  PRODUCT_CLICKED = 'PRODUCT_CLICKED',
  REGIMEN_PRODUCT_VIDEO_PLAYED = 'REGIMEN_PRODUCT_VIDEO_PLAYED',
  REGIMEN_VIEW_UNPAID = 'REGIMEN_VIEW_UNPAID',
  REGIMEN_VIEW_SEE_INSTRUCTION = 'REGIMEN_VIEW_SEE_INSTRUCTION',
  REGIMEN_VIEW_READ_ABOUT_DOCTOR = 'REGIMEN_VIEW_READ_ABOUT_DOCTOR',
  REGIMEN_VIEW_READ_ABOUT_SERVICES = 'REGIMEN_VIEW_READ_ABOUT_SERVICES',
  REGIMEN_VIEW_READ_ABOUT_PRODUCTS = 'REGIMEN_VIEW_READ_ABOUT_PRODUCTS',
  REGIMEN_VIEW_REGIMEN_IMAGE_CLICK = 'REGIMEN_VIEW_REGIMEN_IMAGE_CLICK',
  REGIMEN_VIEW_PRODUCT_IMAGE_CLICK = 'REGIMEN_VIEW_PRODUCT_IMAGE_CLICK',
}
